function checkMobile() {
  if (window.matchMedia("(max-width: 800px)").matches) return true;
  else return false;
}


document.querySelectorAll('.header__submenu .header__menu-item').forEach((item) => {
    item.addEventListener('click', () => {
      if(checkMobile()){
        // closeCartDrawer()
      }
      else{
        document.querySelectorAll('nav.header__inline-menu header-menu>details').forEach((subitem, subindex) => {
          subitem.removeAttribute('open');
          document.querySelector('.che2-desktop-overlay').style.display = 'none';
        })
      }
    })
  
})


// header navigation menu start
if(document.querySelector('.ch2-searchicon ')){
  document.querySelectorAll('.ch2-searchicon ').forEach((item) => {
    item.addEventListener('click', function(){
    document.querySelector('.ch2-1 .search').classList.toggle('search--open');
    document.querySelector('html').style.overflow = 'hidden';
  });
})
}

if(document.querySelector('.ch2-1 .remove-search')){
  document.querySelector('.ch2-1 .remove-search').addEventListener('click', function(){
    document.querySelector('.ch2-1 .search').classList.remove('search--open');
    document.querySelector('html').style.overflow = 'unset';
  })
}

let openCartDrawer = () => {
  document.querySelector('.mobile-menu').style.transform = 'translateX(0)';
  document.querySelector('.mobile-menu-overlay').style.display = 'block';
}
let closeCartDrawer = () => {
  document.querySelector('.mobile-menu').style.transform = 'translateX(-100%)';
  document.querySelector('.mobile-menu-overlay').style.display = 'none';
}

if(document.querySelector('.ch2-hamburger')){
  document.querySelector('.ch2-hamburger').addEventListener('click', function(){
    openCartDrawer()
  })
}

if(document.querySelector('.mobile-menu-overlay')){
  document.querySelector('.mobile-menu-overlay').addEventListener('click', function(){
    closeCartDrawer()
  })
}
if(document.querySelector('.mobile_menu--close')){
  document.querySelector('.mobile_menu--close').addEventListener('click', function(){
    closeCartDrawer()
  })
}
// header navigation menu end

// document.querySelectorAll('nav.header__inline-menu header-menu>details')[2].removeAttribute('open')

document.querySelectorAll('nav.header__inline-menu header-menu>details').forEach((item, index) => {
  item.addEventListener('click', () => {
    console.log('click', item);
    // check if one div is open and if open then close it and then open the one clicked
    const headerid = item.getAttribute('id')
    document.querySelectorAll('nav.header__inline-menu header-menu>details').forEach((subitem, subindex) => {
      if(subitem.getAttribute('id') != headerid){
        subitem.removeAttribute('open');
      }
    })

    // show hide the overlay class
    // let counter = document.querySelectorAll('nav.header__inline-menu header-menu>details[open]').length;
    // console.log('counter ',counter)
    // if (counter > 0) document.querySelector('.che2-desktop-overlay').style.display = 'block';
    // else document.querySelector('.che2-desktop-overlay').style.display = 'none'
  });
});

  document.querySelectorAll('nav.header__inline-menu header-menu>details[open]').forEach((item,index) => {
    item.addEventListener('click', () => {
      document.querySelector('.che2-desktop-overlay').style.display = 'none';
    })
  })
  document.querySelectorAll('nav.header__inline-menu header-menu>details:not([open])').forEach((item,index) => {
    item.addEventListener('click', () => {
      document.querySelector('.che2-desktop-overlay').style.display = 'block';
    })
  })



document.querySelector('.che2-desktop-overlay').addEventListener('click', (event) => {
  document.querySelectorAll('nav.header__inline-menu header-menu>details').forEach((subitem, subindex) => {
      subitem.removeAttribute('open');
      document.querySelector('.che2-desktop-overlay').style.display = 'none';
  })
})